module.exports = __webpack_public_path__ + "static/media/photo2.10c907a4.png";